import $ from 'jquery'
import loading from '@/loading'
import { getOptionsHash } from '@/catalog/product-options'

export const initializePrintMethods = () => {
  // If the user clicks an anchor next to a radio button, make the radio button change,
  // instead of just going to the link.
  $('.radio-anchor').on('click', function (e) {
    e.preventDefault()
    const $input = $(this).parent().find('input')
    $input.prop('checked', true)
    $input.trigger('change')
  })
  const $printMethods = $('input[name=printMethod]')
  $printMethods.on('change', function () {
    const $a = $(this).parent().find('a')
    if ($a.length) {
      loading.show()
      window.location.href = $a.attr('href') + getOptionsHash()
    }
  })

  // Trigger a change on the current checked item, in case the user selected something before JavaScript loaded.
  $printMethods.filter(':checked').trigger('change')
}
